var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { TextInput } from '@/components/ui/Form/TextInput';
export const TextFieldBase = (props) => {
    const { input, inputProps, isError: propIsError, meta, onChange: propsOnChange } = props, textInputProps = __rest(props, ["input", "inputProps", "isError", "meta", "onChange"]);
    const { name, onChange: inputOnChange, value } = input, restInput = __rest(input, ["name", "onChange", "value"]);
    const { dirtySinceLastSubmit, error, submitError, touched } = meta;
    const isError = ((submitError && !dirtySinceLastSubmit) || error) && touched;
    /**
     * onChange
     * @description onChangeCallBack の処理があったら実行する
     */
    const onChange = useCallback((event) => {
        propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange(event);
        inputOnChange(event);
    }, [propsOnChange, inputOnChange]);
    return (_jsx(TextInput, Object.assign({}, textInputProps, { inputProps: Object.assign(Object.assign({}, restInput), inputProps), isError: isError || propIsError, name: name, onChange: onChange, value: value })));
};
